export default __webpack_public_path__ + "static/media/no-pictures.5533b14a.png";